import {API_URL} from "../../dev";

import "isomorphic-fetch";

class EventApi {
	async getEvent(merchantId, themeName, uuid) {
		try {
			const eventResponse = await fetch(
				`${API_URL}/v2/events/search/findByMerchantThemeAndEventUUID?merchantTheme=${merchantId}_${themeName}&eventUUID=${uuid}`);
			const eventObj = await eventResponse.json();
			if (eventResponse.ok) {
				return eventObj;
			}
			throw eventObj;
		} catch (e) {
			console.error(`Error occurred in getEvent ${uuid}: ${JSON.stringify(e)}`,
				`${API_URL}/v2/events/search/findByMerchantThemeAndEventUUID?merchantTheme=${merchantId}_${themeName}&eventUUID=${uuid}`);
			throw e;
		}
	}
}

const eventApi = new EventApi();
export default eventApi;
